import {Injectable} from '@angular/core';


@Injectable()
export class PhoneService {

  parse: any;

  constructor() {
  }

  isUsPhoneNumber(phoneNumber: string) {
    return phoneNumber != null && phoneNumber.startsWith("+1 ");
  }

  setValidPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) {
      return null;
    }
    let mainPhone = phoneNumber;
    phoneNumber = phoneNumber.replace(/[\s\(\)\-]+/g, '');
    if (phoneNumber && phoneNumber.length <= 5) {
      return null;
    } else {
      return mainPhone;
    }
  }
}
